//配置lanhuAPI
import { LanhuAPI } from "lanhu-core"

function setLanhuAPI() {
    let lanhuAPI = new LanhuAPI(`${window.baseURL}/api`)
    window.lanhuAPI = lanhuAPI
    lanhuAPI.apiStorage.enableAuth = true
    lanhuAPI.apiStorage.loginInfo = {
        get token() {
            return localStorage.token
        }
    }
}

export default setLanhuAPI
